import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values = { 
    threshold: { type: Number, default: 350 } 
  }

  connect() {
    this.isVisible = false
    this.boundScroll = this.onScroll.bind(this)
    window.addEventListener("scroll", this.boundScroll)
    this.onScroll() // Initial check in case they reload further down
  }

  disconnect() {
    window.removeEventListener("scroll", this.boundScroll)
  }

  onScroll() {
    const scrollStatus = window.scrollY > this.thresholdValue
    if (this.isVisible === scrollStatus) return
    this.isVisible = scrollStatus

    if (scrollStatus) {
      this.containerTarget.classList.remove("translate-y-full", "opacity-0", "pointer-events-none")
      this.containerTarget.classList.add("translate-y-0", "opacity-100", "pointer-events-auto")
    } else {
      this.containerTarget.classList.remove("translate-y-0", "opacity-100", "pointer-events-auto")
      this.containerTarget.classList.add("translate-y-full", "opacity-0", "pointer-events-none")
    }
  }
}
